import { toast } from 'react-toastify';

import { actions as notificationActions } from 'coupon-common/src/modules/sendNotification/duck';
import { dispatchAsAsync } from 'coupon-common/src/utils';

export const products = {
  PUSH_NOTIFICATIONS_PROD_CODE: 'PUSH_NOTIFICATION'
}

export const sendNotification = async ({
  dispatch,
  coupon,
  businessInfo,
  couponId,
}) => {
  const { title, description } = coupon;
  const firstImage = coupon?.image_url?.[0]?.image_url || null;
  // console.log("inside sendNotification", coupon);
  // console.log("inside sendNotification business", businessInfo);

const type = coupon.type || coupon.couponType;

let value;
if (type === 'percentage_off' || type === 'percentage') {
  value = coupon.percentage_off;
} else if (type === 'amount_off' || type === 'dollar') {
  value = coupon.amount_off;
} else if (type === 'points_back' || type === 'points') {
  value = coupon.points_back;
} else {
  value = coupon.discountValue;
}

  let content;

  if (type === 'percentage_off' || type === 'percentage') {
    content = `${value}% off!`;
  } else if (type === 'amount_off' || type === 'dollar') {
    content = `$${value} off!`;
  } else if (type === 'points_back' || type === 'points') {
    content = `${value} point(s) back!`;
  } else {
    content = 'New coupon available!';
  }

  // https://prnt.sc/5M5SCIvVoJId
  // the title is being updated as business name and content the manually entered title is not sent as the title

  const response = await dispatchAsAsync(
    notificationActions.sendNotification({
      business_id: businessInfo?.id,
      title: `${businessInfo?.name}: ${content}`,
      body: `${title}: ${description}`,
      coupon_id: String(couponId || ''),
      image_url: firstImage
    }),
    dispatch
  );
  

  if (response.success) {
    toast.success('Notification Sent!');
  } else {
    toast.error(response.error || 'Failed to send notification');
  }

  return response;
};

